export default function React_Compiler() {
  return (
    <div>
      <h1>React_Compiler Component</h1>
      <p>This is the React_Compiler tutorial page.</p>
    </div>
  );
}
